<div class="empty-state-container">
    <div class="empty-illustration-wrapper">
        <img class="empty-illustration-img" src="assets/images/empty-state-cam.svg" alt="Manage Bookings" width="180"
            height="134">
        <div class="empty-description-wrapper">
            <!-- <h3 class="title">No project details added</h3>
            <div class="content">
                Add project details to streamline policy and approval workflows.
            </div> -->
            <h3>{{ heading }}</h3>
            <div class="content text-center" [style.width]="width">
                <p>{{ content }}</p>
                <p class="text-center" *ngIf="!IsShow">{{ content1 }}</p>
            </div>
            <a [routerLink]="disableNavigation ? null : navigateTo" *ngIf="IsShow && !isProfileViewRestricted"
                (click)="AddNow($event)" class="link">{{dynamicContent?.['b2b.managecompany.addnew']}}</a>
        </div>
    </div>
</div>